import { Dispatcher } from 'flux';

interface HeroRosterDispatcher extends Dispatcher<{
  source: 'HERO_ROSTER_DISPATCHER';
  action: unknown;
}> {
  DISMISS_HERO: 'DISMISS_HERO';
  HERO_DISMISSED: 'HERO_DISMISSED';
  handleHeroRosterAction: (action: unknown) => void;
}

const dispatcher = new Dispatcher();

export default Object.assign(dispatcher, {
  DISMISS_HERO: 'DISMISS_HERO',
  HERO_DISMISSED: 'HERO_DISMISSED',

  handleHeroRosterAction: function (action: unknown) {
    dispatcher.dispatch({
      source: 'HERO_ROSTER_DISPATCHER',
      action,
    });
  },
}) as HeroRosterDispatcher;
